module.exports = __webpack_public_path__ + "static/media/hinted-MaisonNeue-Book.a6141569.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/maison/hinted-MaisonNeue-Book.ttf
// module id = 225
// module chunks = 0